import { isEmpty, isNull, last, map } from 'lodash/fp';
// @ts-expect-error - Automatic, Please fix when editing this file
import getEligibleRewards from '@ahmdigital/offers/lib/model/offer/get-eligible-rewards';
// @ts-expect-error - Automatic, Please fix when editing this file
import getUpsellApplicableRewards from '@ahmdigital/offers/lib/model/offer/get-upsell-applicable-rewards';
// @ts-expect-error - Automatic, Please fix when editing this file
import isOfferEligible from '@ahmdigital/offers/lib/model/offer/is-eligible';

import generatePresaleSentence from '../utils/generate-presale-sentence';
import ProductPropType from '../../../../types/product';
import useGetActivePromoOffer from '../../logic/use-get-active-promo-offer';
import type { Offer, OfferPresaleText, OfferRewards } from '../../types';

type OfferWithPresaleDetails = {
  offer: Offer;
  presaleSentence: OfferPresaleText;
  rewards: OfferRewards;
};

type UseGetOfferPresaleDetailsResult = {
  loading: boolean;
  data: OfferWithPresaleDetails | null;
};

type GetOfferPresaleDetails = {
  referrerAttribution?: string;
  scenario: {
    product: Partial<ProductPropType>;
    scale: string;
  };
  targetSegment?: string;
};
const useGetOfferPresaleDetails = ({
  referrerAttribution,
  scenario,
  targetSegment,
}: GetOfferPresaleDetails): UseGetOfferPresaleDetailsResult => {
  const { activeOffers: offers, loading }: { activeOffers: Offer[]; loading: boolean } = useGetActivePromoOffer({
    // @ts-expect-error - Automatic, Please fix when editing this file
    referrerAttribution,
    targetSegment,
  });

  if (loading) {
    return { data: null, loading: true };
  }

  if (isNull(offers)) {
    return { data: null, loading: false };
  }
  const scenarioForRewardEligibility = { ...scenario, productId: scenario?.product?.id };

  const getRewards = (offer: Offer): OfferRewards => {
    const eligibleRewards = getEligibleRewards(offer, scenarioForRewardEligibility);
    const upsellApplicableRewards = getUpsellApplicableRewards(offer, scenarioForRewardEligibility);
    return isEmpty(eligibleRewards) ? upsellApplicableRewards : eligibleRewards;
  };

  // @ts-expect-error - Automatic, Please fix when editing this file
  const offersWithPresaleDetails: OfferWithPresaleDetails[] = map(
    (offer: Offer) => ({
      offer,
      presaleSentence: generatePresaleSentence(offer, scenario),
      rewards: getRewards(offer),
    }),
    offers,
  );

  const eligibleOffers = offersWithPresaleDetails.filter(({ offer }) =>
    isOfferEligible(offer, scenarioForRewardEligibility),
  );

  const filteredOffer = isEmpty(eligibleOffers)
    ? last(offersWithPresaleDetails.filter(({ rewards }) => !isEmpty(rewards)))
    : last(eligibleOffers);

  if (!filteredOffer) {
    return { data: null, loading: false };
  }

  return { data: filteredOffer, loading: false };
};

export default useGetOfferPresaleDetails;
